import { PauseFilledSmall, PlayFilledSmall } from "@wix/wix-ui-icons-common";
import React, { useContext } from "react";
import { RicosContext } from "./../../ricos-context/index.js";
import { DoubleLoader } from "./../../ui-components/index.js";
import { AUDIO_ACTION_NAMES, AUDIO_BI_VALUES } from "../consts.js";
import styles from "../statics/styles/audio.rtlignore-scss.js";
import { AUDIO_TYPE } from "../types.js";
const AudioActionIcons = ({
  isPlaying,
  handlePause,
  handlePlay,
  disabled,
  isLoading,
  helpers
}) => {
  const { tabIndex } = useContext(RicosContext);
  const onClick = () => {
    const ACTION_BI_VALUE = isPlaying ? AUDIO_BI_VALUES.PAUSE : AUDIO_BI_VALUES.PLAY;
    helpers?.onViewerAction?.(AUDIO_TYPE, AUDIO_ACTION_NAMES.playAudio, ACTION_BI_VALUE);
    isPlaying ? handlePause() : handlePlay();
  };
  const onKeyDown = (e) => {
    if (e.key === "Enter") {
      onClick();
    }
  };
  const ComponentIcon = disabled || !isPlaying ? PlayFilledSmall : PauseFilledSmall;
  const ariaLabel = isPlaying ? "pause" : "play";
  return isLoading ? /* @__PURE__ */ React.createElement("span", { className: styles.audioLoader }, /* @__PURE__ */ React.createElement(DoubleLoader, null)) : /* @__PURE__ */ React.createElement(
    "button",
    {
      type: "button",
      className: styles.playPauseButton,
      onClick,
      onKeyDown,
      "aria-label": ariaLabel,
      tabIndex
    },
    /* @__PURE__ */ React.createElement(ComponentIcon, null)
  );
};
var AudioActionIcons_default = AudioActionIcons;
export {
  AudioActionIcons_default as default
};
//# sourceMappingURL=AudioActionIcons.js.map
